import React, { useEffect, useState } from "react";
import { useAuthContext } from "hooks/useAuthContext";
import { useSupervisorContext } from "hooks/useSupervisorContext";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Icons
import MDBadge from "components/MDBadge";
import { API_URL } from "../../../../config";
import EditSupervisorPopup from "../components/editSupervisorPopup";
import { toast } from "sonner";

export default function useData() {
  const { user } = useAuthContext();
  const { supervisors, dispatch } = useSupervisorContext();
  const [loading, setLoading] = useState(true); // Add loading state

  //Fetch supervisors from the server
  const fetchSupervisors = async () => {
    try {
      const response = await fetch(
        `${API_URL}/availability/availablesupervisors`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      const supervisorsjson = await response.json();
      if (response.ok) {
        dispatch({ type: "GET_SUPERVISORS", payload: supervisorsjson });
      }
      if (!response.ok) {
        toast.error("Failed to fetch supervisors", {
          description: "Please try again later",
        });
      }
    } catch (error) {
      toast.error("Failed to fetch supervisors", {
        description: "Please try again later",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchSupervisors();
    }
  }, [user, dispatch]);
  // Supervisors from Backend ends here

  if (loading) {
    return {
      columns: [],
      rows1: [],
    };
  }

  // Filter and map supervisors
  const rows = supervisors
    ? supervisors.map((supervisor) => {
        // Check availability for the current academic year
        const currentAvailability = supervisor.Availabilities?.find(
          (availability) => availability.available
        );

        const isAvailable = currentAvailability?.available || false;

        return {
          name: `${supervisor.first_name} ${supervisor.last_name}`,
          email: supervisor.email,
          status: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={isAvailable ? "Available" : "Not Available"}
                color={isAvailable ? "success" : "dark"}
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          edit: (
            <EditSupervisorPopup
              fetchSupervisors={fetchSupervisors}
              supervisor={supervisor}
              isAvailable={isAvailable}
            />
          ),
        };
      })
    : [];

  return {
    columns: [
      { Header: "name", accessor: "name", align: "center" },
      { Header: "email", accessor: "email", align: "center" },
      { Header: "status", accessor: "status", align: "center" },
      { Header: "edit", accessor: "edit", align: "center" },
    ],

    rows1: rows,
  };
}
